import { generateUrl } from "@services/generateUrl/generateUrl"
import { onRequestSuccess, onResponseRejected } from "@services/interceptors"
import axios from "axios"

const DRPROXSERVICES_URL = generateUrl()

const emrServiceApiInstance = axios.create({
    baseURL: `${DRPROXSERVICES_URL}/emr`
})

emrServiceApiInstance.interceptors.request.use(onRequestSuccess, undefined)
emrServiceApiInstance.interceptors.response.use(undefined, onResponseRejected)

export default emrServiceApiInstance
